import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import {KpiCard} from './KpiCard';
import {orangeColors, neutral} from '../../../layouts/theme/designSystem';

type KpiItem = {
  key: 'first' | 'second' | 'third';
};

const KPI_ITEMS: KpiItem[] = [{key: 'first'}, {key: 'second'}, {key: 'third'}];

export const YourAdvantageSection = () => {
  const {t} = useTranslation();

  return (
    <Grid
      id='your-advantage'
      width='100%'
      sx={{
        backgroundColor: '#fff',
        py: {xs: 5, md: 7},
        px: {xs: 2, sm: 3},
        scrollMarginTop: {xs: '96px', md: '140px'},
      }}
    >
      <Typography
        sx={{
          color: orangeColors[900],
          fontWeight: 500,
          fontSize: '1.25rem',
          lineHeight: 1.5,
          textAlign: 'center',
        }}
      >
        {t('b2b.yourAdvantageSection.eyebrow')}
      </Typography>

      <Typography
        sx={{
          mt: 1.5,
          color: neutral['primary-black'],
          fontWeight: 700,
          fontSize: {xs: '2rem', sm: '2.25rem', md: '3rem'},
          lineHeight: 1.2,
          textAlign: 'center',
          maxWidth: '548px',
          mx: 'auto',
        }}
      >
        {t('b2b.yourAdvantageSection.headline')}
      </Typography>

      <Typography
        sx={{
          mt: 2.5,
          color: neutral['primary-black'],
          fontWeight: 400,
          fontSize: {xs: '1.125rem', md: '1.25rem'},
          lineHeight: 1.5,
          textAlign: 'center',
          maxWidth: '654px',
          mx: 'auto',
        }}
      >
        {t('b2b.yourAdvantageSection.description')}
      </Typography>

      <Box
        sx={{
          mt: {xs: 4, md: 5},
          display: 'grid',
          gap: 3,
          gridTemplateColumns: {xs: '1fr', md: 'repeat(3, minmax(0, 1fr))'},
        }}
      >
        {KPI_ITEMS.map(({key}) => (
          <KpiCard
            key={key}
            value={t(`b2b.yourAdvantageSection.kpis.${key}.value`)}
            title={t(`b2b.yourAdvantageSection.kpis.${key}.title`)}
            description={t(`b2b.yourAdvantageSection.kpis.${key}.description`)}
          />
        ))}
      </Box>
    </Grid>
  );
};
